exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btns-holder[data-v-7f0aa0c7] {\n    display: flex;\n    justify-content: flex-end;\n}\nh3.uk-panel-title i[data-v-7f0aa0c7] {\n    margin-right: 5px;\n}\ntd[data-v-7f0aa0c7], th.left[data-v-7f0aa0c7] {\n    text-align: left;\n}\ntd[data-v-7f0aa0c7], th[data-v-7f0aa0c7] {\n    text-align: center;\n}\ntfoot td[data-v-7f0aa0c7] {\n    font-weight: bold;\n}\n", ""]);

// exports
